module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) { fox.registerWidget('SitePage_Home', {
	// configure: function () {

	// 	this.registerOptions('', {
	// 		widgets: {
	// 			crowdFunding: {
	// 				widget: 'CrowdFunding'
	// 			}
	// 		}
			
	// 	});

	// 	this.callParent('configure', arguments);
	// }
}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/home.js
// module id = 888
// module chunks = 4